"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageLoader = exports.PAGE_LOADER_EVENTS = void 0;
var jquery_1 = __importDefault(require("jquery"));
var LocalStorageCache_1 = require("../tools/LocalStorageCache");
var Widget_1 = require("../tools/Widget");
var cache = new LocalStorageCache_1.LocalStorageCache('pageLoader');
exports.PAGE_LOADER_EVENTS = {
    CONTENT_UPDATED: "content.updated"
};
var PageLoader = (function (_super) {
    __extends(PageLoader, _super);
    function PageLoader(node, config) {
        var _this = _super.call(this, node, config) || this;
        _this.loading = false;
        _this.pageTitle = null;
        _this.itemsUpdate = null;
        _this.itemsPending = 0;
        _this.lastLoadedPage = 0;
        _this.allDone = false;
        _this.lastRequest = null;
        _this._cacheKey = null;
        config = _this.config;
        _this.pageTitle = (0, jquery_1.default)("title").text();
        _this.el.on('click', config.trigger, jquery_1.default.proxy(_this.handleClick, _this));
        _this.el.on('click', 'button.update', jquery_1.default.proxy(_this.handleUpdate, _this));
        _this._cacheKey = config.pageUrl + window.location.search;
        _this.contentContainer = _this.el.find(config.container);
        _this.items = _this.extractContentItems(_this.el.find(".results").html());
        if (parseInt((0, jquery_1.default)(_this.el).attr("data-timestamp"), 10) > 0) {
            config.timestamp = (0, jquery_1.default)(_this.el).attr("data-timestamp");
        }
        if (!_this.config.pageSize) {
            config.pageSize = _this.items.length;
        }
        if (config.updateTime) {
            config.updateTime = config.updateTime * 60 * 1000;
            config.useCache = false;
            _this.startUpdate();
        }
        if (_this.useCache()) {
            cache.clean(config.timestamp);
            _this.processCache();
        }
        return _this;
    }
    PageLoader.prototype.dataConfig = function () {
        return [
            'pageUrl',
            'pageParam',
            'timestamp',
            'additionalparams',
            'pageSize',
            'updateTime',
            'authToken'
        ];
    };
    PageLoader.prototype.defaultConfig = function () {
        return {
            timestamp: 0,
            useCache: true,
            trigger: '.load-more',
            container: '.results',
            additionalparams: '',
            pageSize: 0,
            onUpdate: function () { }
        };
    };
    PageLoader.prototype.startUpdate = function () {
        setTimeout(jquery_1.default.proxy(this.checkForUpdate, this), this.config.updateTime);
    };
    PageLoader.prototype.checkForUpdate = function () {
        var _this = this;
        jquery_1.default.ajax({
            url: (0, jquery_1.default)(this.el).attr("data-updateurl"),
            context: this,
            dataType: "json"
        }).done(function (data) {
            _this.itemsUpdate = data;
            _this.setUpdateState(data.count);
        }).always(function () {
            _this.startUpdate();
        });
    };
    PageLoader.prototype.handleUpdate = function () {
        if (!this.itemsUpdate) {
            return;
        }
        (0, jquery_1.default)(this.el).attr("data-updateurl", '?update=true&page=0&time=' + this.itemsUpdate.timestamp);
        this.prependItems(this.extractContentItems(this.itemsUpdate.content));
        this.setUpdateState(0);
        this.itemsUpdate = null;
        this.render();
    };
    PageLoader.prototype.setUpdateState = function (count) {
        this.itemsPending = count;
        this.el.find('button.update')
            .attr("data-count", count)
            .text(count + (count === 1 ? " nieuw artikel weergeven" : " nieuwe artikelen weergeven"));
        if (count > 0) {
            document.title = "(" + count + ") " + this.pageTitle;
        }
        else {
            document.title = this.pageTitle;
        }
    };
    PageLoader.prototype.useCache = function () {
        return (LocalStorageCache_1.LocalStorageCache.enabled && this.config.useCache);
    };
    PageLoader.prototype.processCache = function () {
        var record = cache.get(this._cacheKey);
        if (!record || !record.items) {
            this.cacheState();
        }
        else {
            this.items = record.items;
            this.handleMoreResults(record.moreResults);
            this.render();
            this.lastLoadedPage = Math.floor((this.items.length + this.itemsPending) / this.config.pageSize) || 0;
        }
    };
    PageLoader.prototype.cacheState = function () {
        if (this.useCache()) {
            var record = {
                items: this.items,
                moreResults: this.el.hasClass('more-available')
            };
            cache.set(this._cacheKey, record);
        }
    };
    PageLoader.prototype.getRequestUrl = function (pageNumber) {
        var config = this.config;
        var params = window.location.search.replace("?", "");
        var url = ''.concat(config.pageUrl, "?", config.pageParam, "=", pageNumber.toString());
        if (params) {
            url = url.concat("&", window.location.search.replace("?", ""));
        }
        if (config.additionalparams) {
            url = url.concat(config.additionalparams);
        }
        return url;
    };
    PageLoader.prototype.loadNextPage = function (loadClass) {
        var _this = this;
        if (this.loading || this.allDone) {
            return;
        }
        this.el.addClass(loadClass || 'loading');
        this.loading = true;
        var pageNumber = Math.floor((this.items.length + this.itemsPending) / this.config.pageSize) || 0;
        var requestUrl = this.getRequestUrl(pageNumber);
        if (this.lastLoadedPage <= pageNumber) {
            pageNumber = this.lastLoadedPage + 1;
        }
        this.lastRequest = jquery_1.default.ajax({
            url: requestUrl
        }).done(function (fragment, status, xhr) {
            var items = _this.extractContentItems(fragment);
            var moreResults = xhr.getResponseHeader("moreResults");
            _this.handleMoreResults(moreResults);
            _this.appendItems(items);
            _this.setMinHeight();
            _this.render();
            _this.config.onUpdate.call(_this);
        }).always(function () {
            _this.el.removeClass(loadClass || 'loading');
            _this.loading = false;
            _this.lastLoadedPage = pageNumber;
        });
    };
    PageLoader.prototype.setMinHeight = function () {
        var container = this.getContainer();
        container.css("min-height", container.height());
    };
    PageLoader.prototype.handleClick = function (event) {
        this.loadNextPage();
        PageLoader.getBus().notify('pageLoader.loadMore', (0, jquery_1.default)(event.currentTarget).text());
    };
    PageLoader.prototype.reset = function () {
        if (this.lastRequest) {
            this.lastRequest.abort();
        }
        this.allDone = false;
        this.el.removeClass('all-loaded');
        this.el.removeClass('more-available');
        this.items = [];
        this.loadNextPage('reloading');
    };
    PageLoader.prototype.extractContentItems = function (fragment) {
        var items = [];
        (0, jquery_1.default)(fragment).each(function (index, node) {
            if ((0, jquery_1.default)(node).is("article") && "id" in node && node.id) {
                items.push({
                    id: node.id,
                    html: node.outerHTML
                });
            }
        });
        return items;
    };
    PageLoader.prototype.appendItems = function (items) {
        this.items = removeDuplicates(this.items.concat(items));
        this.cacheState();
    };
    PageLoader.prototype.prependItems = function (items) {
        this.items = removeDuplicates(items.concat(this.items));
        this.cacheState();
    };
    PageLoader.prototype.getContainer = function () {
        return this.el.find(".results");
    };
    PageLoader.prototype.render = function () {
        var resultEl = this.getContainer();
        var currentItems = resultEl.find("> article");
        var index = -1;
        var size = Math.max(this.items.length, currentItems.length);
        var newItem, currentItem;
        while (++index < size) {
            newItem = this.items[index];
            currentItem = currentItems[index];
            if (!currentItem) {
                resultEl.append(newItem.html);
            }
            else if (!newItem) {
                (0, jquery_1.default)(currentItem).remove();
            }
            else {
                (0, jquery_1.default)(currentItem).replaceWith(newItem.html);
            }
        }
        PageLoader.getBus().notify(exports.PAGE_LOADER_EVENTS.CONTENT_UPDATED);
    };
    PageLoader.prototype.handleMoreResults = function (hasMoreResults) {
        if (hasMoreResults === true || hasMoreResults == "true") {
            this.el.removeClass('all-loaded');
            this.el.addClass('more-available');
        }
        else {
            this.allDone = true;
            this.el.addClass('all-loaded');
            this.el.removeClass('more-available');
        }
    };
    return PageLoader;
}(Widget_1.Widget));
exports.PageLoader = PageLoader;
function removeDuplicates(list) {
    var index = -1;
    var size = list.length;
    var processedIds = [];
    var result = [];
    var item;
    while (++index < size) {
        item = list[index];
        if (processedIds.indexOf(item.id) === -1) {
            result.push(item);
            processedIds.push(item.id);
        }
    }
    return result;
}
